// extracted by mini-css-extract-plugin
export default {"container":"TemplateImage_container__vUNdd","disabledOverlay":"TemplateImage_disabledOverlay__aj0MH"};